import classes from './Home6.module.scss';
import CheckIcon from '@mui/icons-material/CheckCircle';

const Home6 = () => {
  return (
    <div className={classes.root}>
      {/* ヘッダー（HERO） */}
      <section className={classes.heroSection}>
        <div className={classes.applicaLogo}>
          <img src="/react-assets/logo.svg" alt="Applica" className={classes.applicaLogoImg} />
        </div>
        <div className={classes.heroContent}>
          <div className={classes.heroText}>
            <h1 className={classes.heroTitle}>
              <span className={classes.titleLine1}>注文・決済・受取</span>
              <span className={classes.titleLine2}>アプリで簡単に</span>
              <span className={classes.titleLine3}>てくてくテイク</span>
            </h1>
            <div className={classes.costText}>低コストで</div>
          </div>
        </div>
        <button className={classes.ctaButton}>無料相談・資料請求　→</button>
      </section>

      {/* NEWS */}
      <section className={classes.newsSection}>
        <div className={classes.sectionTitle}>
          <h2>NEWS</h2>
          <div className={classes.sectionTitleLine}>お知らせ</div>
        </div>

        <div className={classes.newsItem}>
          <span className={classes.newsDate}>2025.08.12</span>
          <p className={classes.newsText}>
            カフェ向けテイクアウト特化アプリ「てくてくテイク」を公開しました。
          </p>
        </div>
      </section>

      {/* ABOUT */}
      <section className={classes.aboutSection}>
        <div className={classes.sectionTitle}>
          <h2>ABOUT</h2>
          <div className={classes.sectionTitleLine}>てくてくテイクについて</div>
        </div>

        <div className={classes.aboutContent}>
          <div className={classes.aboutText}>
            <div className={classes.aboutLogo}>
              <img src="/home6/logo.svg" alt="てくてくテイク" className={classes.siteLogo} />
              <span className={classes.aboutIntro}>
                の<br />
                てくてくテイク。<br />
                テイクアウト特化のカフェ運営アプリ。
              </span>
            </div>
          </div>
          <div className={classes.aboutDevices}>
            <img
              src="/home6/feature-devices.png"
              alt="アプリ利用イメージ"
              className={classes.aboutDevicesImg}
            />
          </div>
          <div className={classes.aboutDetails}>
            <p className={classes.aboutDetailText}>
              <CheckIcon /> クライアント（お客様）は iOS / Android アプリで注文・支払い・受け取り。
            </p>
            <p className={classes.aboutDetailText}>
              <CheckIcon /> カフェ事業者は PC / スマホのブラウザから管理・運用が可能。
            </p>
            <p className={classes.aboutDetailText}>
              <CheckIcon /> 月額料金で導入・運用。テイクアウト特化でスピーディに立ち上げできます。
            </p>
          </div>
        </div>
      </section>

      {/* FEATURES（要件に合わせた2カラム：クライアント／管理） */}
      <section className={classes.featureSection}>
        <div className={classes.sectionTitle}>
          <h2>FEATURE</h2>
          <div className={classes.sectionTitleLine}>機能</div>
        </div>

        {/* クライアント向け機能 */}
        <div className={classes.featureItem}>
          <div className={classes.featureNumber}>CLIENT</div>
          <div className={classes.featureContent}>
            <h3 className={classes.featureTitle}>
              お客様向けアプリ（iOS / Android）
            </h3>
            <div className={classes.featureDescription}>
              <div className={classes.featureImage}>
                <img
                  src="/home6/feature-01-phone.png"
                  alt="クライアント機能イメージ"
                  className={classes.featurePhoneImg}
                />
              </div>
              <div className={classes.featureText}>
                <p><CheckIcon /> メニューの選択</p>
                <p><CheckIcon /> オンライン決済（Stripe 対応）</p>
                <p><CheckIcon /> 現地支払い（現金など）</p>
                <p><CheckIcon /> 購入後のチャットやり取り</p>
                <p><CheckIcon /> 購入後のレシート確認</p>
              </div>
            </div>
          </div>
        </div>

        {/* 管理ページ機能 */}
        <div className={classes.featureItem}>
          <div className={classes.featureNumber}>ADMIN</div>
          <div className={classes.featureContent}>
            <h3 className={classes.featureTitle}>カフェ事業者向け 管理ページ（ブラウザ）</h3>
            <div className={classes.featureDescription}>
              <div className={classes.featureImage}>
                <img
                  src="/home6/feature-02-reviews.png"
                  alt="管理ページ機能イメージ"
                  className={classes.featureReviewImg}
                />
              </div>
              <div className={classes.featureText}>
                <p><CheckIcon /> メニュー管理</p>
                <p><CheckIcon /> 材料（原材料）管理</p>
                <p><CheckIcon /> 納品（仕入れ）管理</p>
                <p><CheckIcon /> カテゴリ管理</p>
                <p><CheckIcon /> オプション管理</p>
                <p><CheckIcon /> 必須フィールド管理</p>
                <p><CheckIcon /> レシート管理</p>
                <p><CheckIcon /> チャット（顧客対応）</p>
                <p><CheckIcon /> 受け取り管理</p>
                <p><CheckIcon /> 売上管理</p>
                <p><CheckIcon /> 来店分析</p>
                <p><CheckIcon /> QRコード決済</p>
                <p><CheckIcon /> スタッフ管理</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 提供形態・プラットフォーム */}
      <section className={classes.functionSection}>
        <div className={classes.functionWrapper}>
          <div className={classes.sectionTitle}>
            <h2>SERVICE</h2>
            <div className={classes.sectionTitleLine}>提供形態</div>
          </div>

          <div className={classes.functionContainer}>
            <h3 className={`${classes.functionContainerTitle} ${classes.functionContainerTitleBasic}`}>
              使い方・導入
            </h3>

            <div className={classes.functionOuter}>
              <div className={classes.functionInner}>
                <p className={classes.functionInnerTitle}>プラットフォーム</p>
                <div className={classes.functionContent}>
                  <div className={classes.functionList}>
                    <div className={classes.functionListItem}>
                      <img src="/home6/icon_function_template.png" alt="クライアント" />
                      <p className={classes.functionListItemText}>クライアント：iOS / Android アプリ</p>
                    </div>
                    <div className={classes.functionListItem}>
                      <img src="/home6/icon_function_ip.png" alt="事業者" />
                      <p className={classes.functionListItemText}>事業者：PC / スマホのブラウザ</p>
                    </div>
                    <div className={classes.functionListItem}>
                      <img src="/home6/icon_function_calender.png" alt="料金" />
                      <p className={classes.functionListItemText}>料金：月額制（詳細はお問い合わせ）</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={classes.functionInner}>
                <p className={classes.functionInnerTitle}>導入メリット</p>
                <div className={classes.functionContent}>
                  <div className={classes.functionList}>
                    <div className={classes.functionListItem}>
                      <img src="/home6/icon_function_up.png" alt="特化" />
                      <p className={classes.functionListItemText}>テイクアウト特化のUI/運用</p>
                    </div>
                    <div className={classes.functionListItem}>
                      <img src="/home6/icon_function_parametar.png" alt="拡張" />
                      <p className={classes.functionListItemText}>拡張しやすい構成（オプション設定）</p>
                    </div>
                    <div className={classes.functionListItem}>
                      <img src="/home6/icon_function_kidou.png" alt="効率化" />
                      <p className={classes.functionListItemText}>注文〜受け取りを効率化</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 競合比較 */}
            <h3 className={`${classes.functionContainerTitle} ${classes.functionContainerTitleOption}`}>
              競合との違い
            </h3>
            <div className={classes.functionBox}>
              <div className={classes.functionBoxTitle}>
                <h3 className={classes.functionBoxTitleText}>
                  <span className={classes.yellowBack}>テイクアウトに最適化</span>されたプロダクト
                </h3>
              </div>
              <div className={classes.textImgFlex}>
                <div className={classes.textImgFlexContent}>
                  <ul className={classes.textImgFlexContentList}>
                    <li className={classes.textImgFlexContentListItem}>
                      <span>BASE / STORES</span>：EC（オンライン発送）が主軸。てくてくテイクは<strong>店頭テイクアウトが主軸</strong>。
                    </li>
                    <li className={classes.textImgFlexContentListItem}>
                      <span>Picks（ピックス）</span>：<strong>完全な競合</strong>。当社は管理機能の柔軟性と拡張性で差別化。
                    </li>
                  </ul>
                </div>
                <img
                  className={classes.textImgFlexImg}
                  src="/home6/option-dev.png"
                  alt="競合比較イメージ"
                />
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className={classes.ctaSection}>
            <a
              href="#contact"
              className={`${classes.kvCtaBtn} ${classes.ctaSectionButton} ${classes.ctaSectionButtonContact}`}
            >
              お問い合わせ
              <svg width="18" height="18" viewBox="0 -1 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.25 1.25L14.75 8.25M14.75 8.25L9.25 14.75M14.75 8.25H1.25"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a
              href="#document"
              className={`${classes.kvCtaBtn} ${classes.ctaSectionButton} ${classes.ctaSectionButtonDocument}`}
            >
              資料請求
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_674_8996)">
                  <path
                    d="M15.75 9V12.15C15.75 13.4101 15.75 14.0402 15.5048 14.5215C15.289 14.9448 14.9448 15.289 14.5215 15.5048C14.0402 15.75 13.4101 15.75 12.15 15.75H5.85C4.58988 15.75 3.95982 15.75 3.47852 15.5048C3.05516 15.289 2.71095 14.9448 2.49524 14.5215C2.25 14.0402 2.25 13.4101 2.25 12.15V9"
                    stroke="#222222"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    className={classes.downArrow}
                    d="M6 6.75L9 9.75M9 9.75L12 6.75M9 9.75V0.75"
                    stroke="#222222"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_674_8996">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home6;
